import { useInView } from 'react-intersection-observer'

import './lazy-image.styl'

function LazyImage({ src, alt, className, height }) {
  const { ref, inView } = useInView({
    triggerOnce: true,
    rootMargin: '200px',
  })

  return (
    <div ref={ref} className="lazy-image">
      {inView
        ? (
            <img src={src} alt={alt} className={className} />
          )
        : (
            <div style={{ height: height, background: '#eee' }} />
          )}
    </div>
  )
};

export default LazyImage
